<!--SMALL SCREEN-->
<ng-container *ngIf="responsiveService.isScreenSmall()">
    <!--provide-estimate -->
    <provide-estimate> </provide-estimate>
    <mat-divider class="divider"></mat-divider>
    <!--results-->
    <results></results>
</ng-container>



<!--BIG SCREEN-->
<ng-container *ngIf="!responsiveService.isScreenSmall()">
    <div class="poker-room-container">
        <div class="row">
            <!--midldle -->
            <div class="column middle">
                <ng-container>
                    <whocan-alert-1></whocan-alert-1>
                </ng-container>
                <!--provide-estimate -->
                <provide-estimate>
                </provide-estimate>
                <mat-divider class="divider"></mat-divider>

                <!--results-->
                <div class="results">
                    <results></results>
                </div>

            </div>
        </div>
    </div>
</ng-container>
